import React, { useEffect } from "react";
import styles from "./ImagePicker.module.scss";
import defaultProductImage from "../../../assets/images/product-single.jpg";
import { useFilePicker } from "./useFilePicker";

export default function VideoPicker(props) {
  const { click, file } = useFilePicker({ format: "video/*" });
  const defaultVideo = props.defaultVideo || defaultProductImage;

  useEffect(() => {
    if (!file) return;
    props.onChange && props.onChange(file);
  }, [file]);

  return (
    <div
      className={`${styles.container}`}
    >
      <video
        className={styles.image}
        src={(file && file.url) || defaultVideo}
        controls
        alt=""
      />
      <button className={styles.btn} onClick={click}>
        <i className="fa fa-edit" />
      </button>
    </div>
  );
}
